{
  "VALIDATION_FAILED": "يرجى التحقق من البيانات المدخلة",
  "UNAUTHENTICATED": "يجب تسجيل الدخول",
  "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "TOKEN_EXPIRED": "انتهت صلاحية الجلسة",
  "TOKEN_REVOKED": "تم إلغاء الجلسة",
  "NO_PLATFORM_ACCESS": "لا تملك صلاحية الوصول لهذه المنصة",
  "UA_UNAVAILABLE": "نظام التحقق الموحد غير متاح حاليا",
  "FORBIDDEN": "ليس لديك صلاحية لتنفيذ هذا الإجراء",
  "NOT_FOUND": "العنصر المطلوب غير موجود",
  "routeNotFound": "هذه الصفحة غير موجودة.",
  "CONFLICT": "تعارض في البيانات",
  "UNIQUE_VIOLATION": "القيمة مستخدمة مسبقا",
  "FOREIGN_KEY_VIOLATION": "العنصر مرتبط بعناصر أخرى",
  "RATE_LIMITED": "عدد كبير من المحاولات، حاول لاحقا",
  "IDEMPOTENCY_KEY_REUSED": "تم استخدام مفتاح الطلب لعملية أخرى",
  "REQUEST_IN_PROGRESS": "لا يزال الطلب قيد المعالجة",
  "PAYLOAD_TOO_LARGE": "حجم البيانات كبير جدا",
  "UNPROCESSABLE": "تعذر تنفيذ الطلب",
  "INTERNAL_ERROR": "تعذر إكمال العملية. أعد المحاولة أو راجع المسؤول.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة حاليا",
  "NO_QUANTITY": "يجب إدخال كمية لبرميل واحد أو جركل واحد على الأقل",
  "NON_POSITIVE_TOTAL": "الإجمالي بعد خصم الجراكل يجب أن يكون أكبر من صفر",
  "LESS_JERRYCANS_EXCEED_TOTAL": "قيمة إلا جركل أكبر من مجموع الجراكل",
  "REVOLVING_BALANCE_REQUIRED": "لا يوجد شفت مفتوح حاليا. يرجى الانتظار حتى يتم فتح شفت جديد قبل إجراء أي حركة.",
  "DEBT_LIMIT_EXCEEDED": "المبلغ مع الدين الحالي يتجاوز سقف الدين البالغ {{limit}} دينار",
  "VEHICLE_NOT_OF_DEBTOR": "المركبة المختارة لا تتبع هذا المدين",
  "WRONG_CLOSE_PASSWORD": "كلمة مرور خاطئة",
  "CLOSE_PASSWORD_NOT_SET": "لم يتم تعيين كلمة مرور إغلاق الشفت، تواصل مع المسؤول",
  "CLOSE_TEMPORARILY_BLOCKED": "تم إيقاف الإغلاق بسبب تكرار كلمة المرور الخاطئة، حاول بعد 15 دقيقة",
  "SYSTEM_FROZEN": "النظام مجمد مؤقتا لعملية إدارة السنوات",
  "ALREADY_DELIVERED": "تم التسليم مسبقا بواسطة {{name}} في {{time}}",
  "NOT_DELIVERABLE": "لا يمكن تسليم هذه الحركة",
  "MESSAGE_NOT_RETRYABLE": "لا يمكن إعادة إرسال هذه الرسالة",
  "WRONG_PASSWORD": "كلمة المرور غير صحيحة",
  "YEAR_PRECONDITION_FAILED": "أكمل النسخة الاحتياطية والترحيل إلى الأرشيف وتحقق منهما أولا",
  "CATEGORY_NOT_AVAILABLE": "التصنيف غير موجود",
  "PRODUCT_NOT_ALLOWED": "ليس لديك صلاحية على هذا المنتج",
  "BRANCH_NOT_ALLOWED": "ليس لديك صلاحية على هذا الفرع",
  "SYSTEM_GROUP_PROTECTED": "لا يمكن حذف مجموعة مدير النظام أو تفريغها",
  "ARCHIVE_READ_ONLY": "الأرشيف للقراءة فقط",
  "network": "تعذر الاتصال بالخادم",
  "timeout": "لم يتم تأكيد اكتمال العملية. تحقق من الحالة قبل إعادة المحاولة.",
  "referenceId": "رقم المرجع: {{requestId}}",
  "PDA_NET_QUANTITY_NOT_POSITIVE": "صافي الكمية يجب أن يكون أكبر من صفر",
  "PDA_CATEGORY_MISSING": "خيار الكمية المحدد لم يعد متاحا، أعد تحميل الصفحة وحاول مجددا",
  "PDA_CUSTOMER_EXISTS": "العميل مسجل مسبقا",
  "PDA_TRANSACTION_NOT_FOUND": "لم يتم العثور على الحركة",
  "PDA_NOT_A_SALE": "هذه الحركة ليست بيعا",
  "PDA_TRANSACTION_CANCELLED": "الحركة ملغاة",
  "PDA_WHATSAPP_DISABLED": "إرسال واتساب غير مفعل",
  "FORBIDDEN_PRODUCT": "لا تملك صلاحية هذه المادة",
  "PURCHASE_ALREADY_PRICED": "تم تسعير هذه العملية مسبقا",
  "NATIONALITY_NAME_EXISTS": "اسم الجنسية مستخدم مسبقا",
  "PHONE_TAKEN": "رقم الهاتف مسجل لعميل آخر، يرجى إدخال رقم آخر",
  "PHONE_CHANGED": "تم تغيير رقم الهاتف من مكان آخر، أعد التحميل وحاول مجددا",
  "CUSTOMERS_UNAVAILABLE": "تعذر التحقق من الرقم لدى نظام العملاء ولم يتم الحفظ، حاول مجددا",
  "CUSTOMERS_CUSTOMER_NOT_FOUND": "العميل غير موجود في نظام العملاء، ربما تم حذفه، ولم يتم الحفظ",
  "CUSTOMERS_REFUSED": "رفض نظام العملاء تعديل الرقم ولم يتم الحفظ، يرجى مراجعة مسؤول النظام",
  "WRONG_OVERVIEW_PASSWORD": "كلمة مرور خاطئة",
  "OVERVIEW_PASSWORD_NOT_SET": "لم يتم تعيين كلمة مرور لمحة عامة بعد",
  "OVERVIEW_TEMPORARILY_BLOCKED": "تم إيقاف العرض بسبب تكرار كلمة المرور الخاطئة، حاول بعد 15 دقيقة",
  "INVENTORY_MODE_ACTIVE": "وضع الجرد ما زال مفعلا: أكد إجبار الترحيل",
  "NO_OPEN_SHIFT": "لا يوجد شفت مفتوح: أدخل الرصيد المدور لتاريخ العمل الحالي أولا",
  "ALREADY_POSTED": "تم ترحيل الحركة مسبقا",
  "PENDING_NOT_COMPLETED": "أكمل سعر الحركة قبل ترحيلها",
  "INVALID_TRANSACTION_CODE": "رقم الحركة غير صالح",
  "TRANSACTION_NOT_FOUND": "لم يتم العثور على الحركة",
  "TRANSACTION_CANCELLED": "الحركة ملغاة",
  "WRONG_PRODUCT": "هذه الحركة من مادة أخرى، انتقل إلى المادة الأخرى للمتابعة",
  "NO_ACTION_AVAILABLE": "لا يوجد إجراء متاح لهذه الحركة",
  "SALE_ALREADY_PRICED": "تم إكمال هذه الحركة مسبقا",
  "SALE_NOT_COMPLETED": "لم يكتمل البيع بعد، أرسل العميل إلى المكتب لإكماله",
  "DEBTOR_BRANCH_MISMATCH": "المدين لا يتبع لفرع الحركة",
  "fieldCodes": {
    "unknown_nationality": "الجنسية غير معروفة",
    "required": "هذا الحقل مطلوب",
    "not_found": "القيمة غير موجودة"
  },
  "PHONE_REQUIRED": "رقم الهاتف مطلوب",
  "PHONE_INVALID": "رقم الهاتف غير صالح",
  "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
  "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة",
  "PHONE_VERIFICATION_REQUIRED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "PHONE_VERIFICATION_INVALID": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "OTP_INVALID": "الرمز غير صحيح، تبقى {{attemptsLeft}} محاولات",
  "OTP_EXPIRED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_ATTEMPTS_EXCEEDED": "تم تجاوز عدد المحاولات، اطلب رمزا جديدا",
  "OTP_RESEND_TOO_SOON": "إعادة الإرسال بعد {{retryAfterSeconds}} ثانية",
  "OTP_SEND_LIMIT": "تم إرسال عدد كبير من الرموز لهذا الرقم، حاول بعد {{minutes}} دقيقة",
  "OTP_SEND_FAILED": "تعذر إرسال رمز التحقق عبر واتساب ولم يتم الحفظ. حاول مجددا، أو يمكن للمسؤول إيقاف تأكيد الرقم من الإعدادات",
  "OTP_ALREADY_VERIFIED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_ALREADY_CONSUMED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_BINDING_MISMATCH": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_NOT_VERIFIED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_CONSUME_WINDOW_PASSED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "IDEMPOTENCY_CONFLICT": "تم استخدام مفتاح الطلب لعملية أخرى",
  "CUSTOMERS_CALL_IN_FLIGHT": "جاري إرسال بيانات العميل إلى نظام العملاء، أعد المحاولة بعد لحظات"
}
